/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';

// stg環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'https://mj2r4fv48c.execute-api.ap-northeast-1.amazonaws.com/stg',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'https://c4a9yym4o9.execute-api.ap-northeast-1.amazonaws.com/stg',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'stg',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-WYHX80GMFN',
  inquiryFormUrl: 'about:blank',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'about:blank',
  ymPublishedBibliograpyUrl: 'about:blank',
  siteDomain: 'stg.manabi.poplar.co.jp',
  adminUrl: 'https://admin.stg.manabi.poplar.co.jp',
  yomokkaUrl: 'https://yomokka.stg.manabi.poplar.co.jp',
  sagasokkaUrl: 'https://sagasokka.stg.manabi.poplar.co.jp',
  mottosokkaUrl: 'https://stg.manabi.poplar.co.jp',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: '2790c8fc-c759-4721-bf12-9e10af619441',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '932716673281-aorjvdtl3o1mme7np0pab0ktsv5qd5nj.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: 'https://stg.manabi.poplar.co.jp/maintenance/info.txt',
  maintenanceExpiryUrl: 'https://stg.manabi.poplar.co.jp/maintenance/expiry.txt',
};

export default config;
